import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
const layerVideo = {
	show: ($element) => {
		const source = $element.attr('data-src');
	    // const plyrEmbedId = $element.attr('data-plyr-embed-id');
		const layerHTML = `<div class="comm-layer flyr-layer show">
							<div class="comm-layer-bg"></div>
							<span class="clayer-close js-close-flyrlayer icon-close white fz-32"></span>
							<div class="clayer-main">
								<div class="clayer-container">
									<div class="flayer-wrap">
										<video class="flyr-box" playsinline controls data-poster="">
											<source src="`+source+`" type="video/mp4" />
										</video>
									</div>
								</div>
							</div>
						</div>`
		$('body').append(layerHTML);
		const player = new Plyr(document.querySelector('.flyr-box'), {
			autoplay: true
		});
	}
}

export { layerVideo }